import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button.js';
import type { VersionInfo } from '../../hooks/useProjects.js';

interface Props {
  versions: VersionInfo[];
  currentVersion: number;
  selectedVersion: number;
  onSelect: (v: number) => void;
}

export function VersionSelector({ versions, currentVersion, selectedVersion, onSelect }: Props) {
  const { t } = useTranslation();

  if (versions.length <= 1) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--evo-space-2)' }}>
      <span style={{
        fontSize: 'var(--evo-fs-label)',
        color: 'var(--evo-fg-4)',
        fontFamily: 'var(--evo-font)',
        userSelect: 'none',
      }}>
        {t('projects.versions.label')}:
      </span>
      <div style={{ display: 'flex', gap: 'var(--evo-space-1)', flexWrap: 'wrap' }}>
        {versions.map(v => {
          const isSelected = v.version === selectedVersion;
          const isCurrent = v.version === currentVersion;
          return (
            <Button
              key={v.version}
              variant="outline"
              tone={isSelected ? 'cyan' : 'muted'}
              size="xs"
              onClick={() => onSelect(v.version)}
            >
              v{v.version}{isCurrent ? ` (${t('projects.versions.current')})` : ''}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
